import React from "react";
import Routers from "./routers";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ConfigProvider } from "antd";

function App() {
  return (
    <ConfigProvider
      theme={{
        token: {
          // Seed Token
          colorPrimary: "#20D072",
          colorPrimaryHover: "#333",
          borderRadius: 4,
          colorFill: "#001B22",
          colorIcon: "#001B22",
          colorBgContainer: "#fff",
        },
        components: {
          Button: {
            colorPrimary: "#20D072",
            colorPrimaryHover: "#20D072CC",
            boxShadow: 0,
          },
          Input: {
            lineWidthFocus: 1,
            hoverBorderColor: "#777",
            colorBgContainer: "#363636", // cor de fundo
            colorText: "#fff",
            colorBgBase: "#363636",
            colorTextPlaceholder: "#777",
            colorFill: "#fff",
            colorText: "#fff",
            colorTextPlaceholder: "#777",
          },
        },
      }}
    >
      <Routers />
      <ToastContainer autoClose={3000} theme="colored" />
    </ConfigProvider>
  );
}

export default App;
